import React from 'react'

import Flex from 'styled-flex-component'

import AnalyticsAudienceReportingWrapper from '@components/Analytics/AudienceReporting'
import CampaignSideBar from '@components/Campaign/SideBar/SideBar'
import ReportsTitleBar from '@components/Reports/TitleBar/TitleBar'
import MainLayout from '@components/UI/MainLayout'
import PaddedContainerStyled from '@components/UI/PaddedContainer/PaddedContainer.styled'
import AnalyticsTrackingProvider from '@context/AnalyticsTracking'
import { CampaignProvider } from '@context/Campaign'
import { DrawerProvider } from '@context/Drawer'
import { ModalProvider } from '@context/Modal'
import SubmissionListFilterProvider from '@context/SubmissionListFilter/Provider'
import Theme from '@theme'

const AudienceReportingPage: React.FC = () => (
  <MainLayout backgroundColor={Theme.whiteColor}>
    <CampaignProvider>
      <SubmissionListFilterProvider>
        <AnalyticsTrackingProvider>
          <DrawerProvider>
            <ModalProvider>
              <ReportsTitleBar />
              <Flex>
                <CampaignSideBar />
                <Flex column full>
                  <PaddedContainerStyled>
                    <AnalyticsAudienceReportingWrapper />
                  </PaddedContainerStyled>
                </Flex>
              </Flex>
            </ModalProvider>
          </DrawerProvider>
        </AnalyticsTrackingProvider>
      </SubmissionListFilterProvider>
    </CampaignProvider>
  </MainLayout>
)

export default AudienceReportingPage
